import apiService from '../apiService';
import profileConfig from './profileConfig';

const profileService = {

	retrieveStaffProfile: (request) => {
		return apiService ('retrieveStaffProfile', profileConfig, request);
	}

};

export default profileService;
